import styled from 'styled-components'
import ButtonIcon from '@/components/common/ButtonIcon'
import { device } from '@/common/constants/device'

const ButtonClose = styled(ButtonIcon)`
  width: 24px;
  height: 24px;
  cursor: pointer;
  background-color: var(--tertiary);
  transition: transform 0.26s ease-in-out;
  flex-shrink: 0;
`

const ButtonCloseWrap = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  cursor: pointer;

  @media ${device.tablet} {
    width: 24px;
    height: 24px;
  }

  &:hover {
    ${ButtonClose} {
      transform: rotate(90deg);
    }
  }
`

const BaseButtonClose = ({ close, className = '' }) => {
  return (
    <ButtonCloseWrap className={className} onClick={close}>
      <ButtonClose type="button" icon="creatives-close" />
    </ButtonCloseWrap>
  )
}

export default BaseButtonClose
